import { FormInstance } from "antd/es/form";
import React from "react";
import { IValidationData } from "../../models/dto/validation-data";
import { KContext } from "../../shared/hoc/with-context";
import { KNavigator } from "../../shared/hoc/with-history";
import { KuikaAppManager } from "../../shared/utilty/kuika-app-manager";
import { KMainFunctions } from "../../shared/utilty/main-functions";
import { ReactSystemFunctions } from "../../shared/utilty/react-system-functions";

declare let window: any;

export interface IYuklemePlanDetay_ScreenProps {
  navigator: KNavigator;
  form: FormInstance<any>;
  googleLogin: any;
  screenInputs: any;
  context: KContext;
  initialValues: any;
  children: any;
}

interface IYuklemePlanDetay_ScreenState {
  isSpinnerVisible: boolean;
  isPageVisible: boolean;
  isLeftMenuVisible: boolean;
  spinnerCount: number;
  selectedLanguage: string;
  isPageInitLoaded: false;
  isPageRecurringLoaded: false;
  Get_Helpers_UserInfoByUserName: any[];
  Get_Helpers_UserInfoByUserName_dummy: any[];
  Get_Tanim_MusteriListe: any[];
  Get_Tanim_MusteriListe_dummy: any[];
  YuklemePlan_Get_DetailById: any[];
  YuklemePlan_Get_DetailById_dummy: any[];
  Get_Tanim_MusteriNoktaListe: any[];
  Get_Tanim_MusteriNoktaListe_dummy: any[];
  YuklemePlan_Get_MasterById: any[];
  YuklemePlan_Get_MasterById_dummy: any[];
  GoBack: any;
  GoBack_dummy: any;
  YuklemePlan_Update_Detail: number;
  YuklemePlan_Update_Detail_dummy: number;
  GetMailBody_TedarikciPlanDetayGuncelleme: string;
  GetMailBody_TedarikciPlanDetayGuncelleme_dummy: string;
  SendMail: boolean;
  SendMail_dummy: boolean;
}

export class YuklemePlanDetay_ScreenBase extends React.PureComponent<
  IYuklemePlanDetay_ScreenProps,
  any
> {
  yuklemeplandetay_591289_value_kuikaAutoCompleteRef: React.RefObject<any>;
  yuklemeplandetay_899912_value_kuikaAutoCompleteRef: React.RefObject<any>;
  ml = [
    {
      Id: "585b6303-ac4a-473f-8893-c915ede3bf84",
      Name: "en_US",
      ShortName: "English",
      IsDefault: true,
      LanguagePhrases: [],
    },
    {
      Id: "e208ee4e-46d8-4265-a1a5-8b409a3a7380",
      Name: "FixedValues",
      ShortName: "FixedValues",
      LanguagePhrases: [
        {
          Id: 359976,
          PropertyName: "value",
          Value: "YÜKLEME PLAN DETAY BİLGİSİ",
        },
        { Id: 304889, PropertyName: "value", Value: "Teslimat No" },
        { Id: 14253, PropertyName: "value", Value: "Ürün Adı" },
        { Id: 385873, PropertyName: "value", Value: "Palet  Adedi" },
        { Id: 903658, PropertyName: "placeholder", Value: "Type here..." },
        { Id: 305509, PropertyName: "value", Value: "Koli Adedi" },
        { Id: 456493, PropertyName: "placeholder", Value: "Type here..." },
        { Id: 557676, PropertyName: "value", Value: "Ağırlık" },
        { Id: 355838, PropertyName: "placeholder", Value: "Type here..." },
        { Id: 250704, PropertyName: "value", Value: "Mikro Dağıtım" },
        { Id: 948405, PropertyName: "value", Value: "Mikro Dağıtım Firma" },
        { Id: 591289, PropertyName: "placeholder", Value: "Search..." },
        { Id: 326784, PropertyName: "value", Value: "Mikro Dağıtım Depo" },
        { Id: 899912, PropertyName: "placeholder", Value: "Search..." },
        { Id: 674442, PropertyName: "label", Value: "Vazgeç" },
        { Id: 869540, PropertyName: "label", Value: "Güncelle" },
      ],
    },
  ];
  defaultML = "en_US";

  screenHash = "";

  constructor(props) {
    super(props);
    this.yuklemeplandetay_903658_value_kuikaTextInputRef = React.createRef();
    this.yuklemeplandetay_456493_value_kuikaTextInputRef = React.createRef();
    this.yuklemeplandetay_355838_value_kuikaTextInputRef = React.createRef();
    this.yuklemeplandetay_591289_value_kuikaAutoCompleteRef = React.createRef();
    this.yuklemeplandetay_899912_value_kuikaAutoCompleteRef = React.createRef();

    this.state = {
      isSpinnerVisible: false,
      isPageVisible: false,
      isLeftMenuVisible: false,
      spinnerCount: 0,
      selectedLanguage: "",
      isPageInitLoaded: false,
      isPageRecurringLoaded: false,
      Get_Helpers_UserInfoByUserName: [],
      Get_Tanim_MusteriListe: [],
      YuklemePlan_Get_DetailById: [],
      Get_Tanim_MusteriNoktaListe: [],
      YuklemePlan_Get_MasterById: [],
      GoBack: "",
      YuklemePlan_Update_Detail: 0,
      GetMailBody_TedarikciPlanDetayGuncelleme: "",
      SendMail: false,
    };

    this.state.isPageVisible = true;
  }

  async componentDidMount() {
    if (KuikaAppManager.isPageInitPrevented()) {
      KuikaAppManager.calculateAndSetBodyHeight("yuklemeplandetay", "");
      return;
    }

    ReactSystemFunctions.validateToken();
    this.fillFormInitValues();
    if (true) {
      await this.YuklemePlanDetayPageInit();
    }

    KuikaAppManager.calculateAndSetBodyHeight("yuklemeplandetay", "");

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = this;
    }
  }

  componentWillUnmount() {
    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = null;
    }
  }

  componentDidUpdate = async (prevProps, prevState) => {
    KuikaAppManager.calculateAndSetBodyHeight("yuklemeplandetay", "");
    if (prevProps?.location?.search !== (this.props as any)?.location?.search) {
      await this.YuklemePlanDetayPageInit();
    }

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      for (const key in prevState) {
        if (
          key.startsWith("NavVisible") &&
          prevState[key] === true &&
          this.state[key] === false
        ) {
          window.parentScreen = this;
          break;
        }
      }
    }
  };

  fillFormInitValues() {
    this.props.form?.setFieldsValue({
      yuklemeplandetay_903658_value:
        this.state.YuklemePlan_Get_DetailById?.at?.(0)?.yuklenenPaletSayisi ??
        undefined,
      yuklemeplandetay_456493_value:
        this.state.YuklemePlan_Get_DetailById?.at?.(0)?.yuklenenKoliAdedi ??
        undefined,
      yuklemeplandetay_355838_value:
        this.state.YuklemePlan_Get_DetailById?.at?.(0)?.yuklenenPaletAgirlik ??
        undefined,
      yuklemeplandetay_728519_value:
        this.state.YuklemePlan_Get_DetailById?.at?.(0)?.mikroDagitimVar ??
        undefined,
      yuklemeplandetay_591289_value:
        this.state.YuklemePlan_Get_DetailById?.at?.(0)?.mikroDagitimFirmaId ??
        undefined,
      yuklemeplandetay_899912_value:
        this.state.YuklemePlan_Get_DetailById?.at?.(0)?.mikroDagitimNokta ??
        undefined,
    });
  }

  setPageInitLoaded = (value: boolean) => {
    this.setState({ isPageInitLoaded: value });
  };

  setPageRecurringLoaded = (value: boolean) => {
    this.setState({ isPageRecurringLoaded: value });
  };

  clearFieldValidation = (changedValues: any) => {
    const fieldName = Object.keys(changedValues)[0];
    if (fieldName) {
      this.props.form?.setFields([
        {
          name: fieldName,
          errors: [],
        },
      ]);
    }
  };

  YuklemePlanDetayPageInit = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {
      UserName_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.getMyUsername(),
        "string"
      ),
      UserId_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.Get_Helpers_UserInfoByUserName !== undefined
            ? stateVars.Get_Helpers_UserInfoByUserName?.length > 0
              ? stateVars.Get_Helpers_UserInfoByUserName[0].id
              : null
            : this.state.Get_Helpers_UserInfoByUserName?.length > 0
            ? this.state.Get_Helpers_UserInfoByUserName[0].id
            : null
        ),
        "Guid"
      ),
      FTL_1: ReactSystemFunctions.convertToTypeByName(true, "boolean"),
      LTL_1: ReactSystemFunctions.convertToTypeByName(true, "boolean"),
      YuklemeDetayId_2: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.YuklemeDetayId ??
          this.props.screenInputs.yuklemedetayid,
        "Guid"
      ),
      MusteriId_3: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "yuklemeplandetay_591289_value",
            "value",
            "Get_Tanim_MusteriListe",
            "id",
            "id"
          )
        ),
        "Guid"
      ),
      UserId_3: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.Get_Helpers_UserInfoByUserName !== undefined
            ? stateVars.Get_Helpers_UserInfoByUserName?.length > 0
              ? stateVars.Get_Helpers_UserInfoByUserName[0].id
              : null
            : this.state.Get_Helpers_UserInfoByUserName?.length > 0
            ? this.state.Get_Helpers_UserInfoByUserName[0].id
            : null
        ),
        "Guid"
      ),
      YuklemeId_4: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.YuklemeId ?? this.props.screenInputs.yuklemeid,
        "Guid"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "YuklemePlanDetay/YuklemePlanDetayPageInit",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.Get_Helpers_UserInfoByUserName =
      result?.data.get_Helpers_UserInfoByUserName;
    stateVars.Get_Tanim_MusteriListe = result?.data.get_Tanim_MusteriListe;

    formVars.yuklemeplandetay_591289_options = stateVars.Get_Tanim_MusteriListe;
    formVars.yuklemeplandetay_591289_value =
      stateVars.YuklemePlan_Get_DetailById !== undefined
        ? stateVars.YuklemePlan_Get_DetailById?.length > 0
          ? stateVars.YuklemePlan_Get_DetailById[0].mikroDagitimFirmaId
          : null
        : this.state.YuklemePlan_Get_DetailById?.length > 0
        ? this.state.YuklemePlan_Get_DetailById[0].mikroDagitimFirmaId
        : null;
    stateVars.YuklemePlan_Get_DetailById =
      result?.data.yuklemePlan_Get_DetailById;
    formVars.yuklemeplandetay_197656_value = ReactSystemFunctions.toString(
      this,
      stateVars.YuklemePlan_Get_DetailById !== undefined
        ? stateVars.YuklemePlan_Get_DetailById?.length > 0
          ? stateVars.YuklemePlan_Get_DetailById[0].teslimatNo
          : null
        : this.state.YuklemePlan_Get_DetailById?.length > 0
        ? this.state.YuklemePlan_Get_DetailById[0].teslimatNo
        : null
    );
    formVars.yuklemeplandetay_770540_value = ReactSystemFunctions.toString(
      this,
      stateVars.YuklemePlan_Get_DetailById !== undefined
        ? stateVars.YuklemePlan_Get_DetailById?.length > 0
          ? stateVars.YuklemePlan_Get_DetailById[0].urunAdi
          : null
        : this.state.YuklemePlan_Get_DetailById?.length > 0
        ? this.state.YuklemePlan_Get_DetailById[0].urunAdi
        : null
    );
    formVars.yuklemeplandetay_903658_value = ReactSystemFunctions.toString(
      this,
      stateVars.YuklemePlan_Get_DetailById !== undefined
        ? stateVars.YuklemePlan_Get_DetailById?.length > 0
          ? stateVars.YuklemePlan_Get_DetailById[0].yuklenenPaletSayisi
          : null
        : this.state.YuklemePlan_Get_DetailById?.length > 0
        ? this.state.YuklemePlan_Get_DetailById[0].yuklenenPaletSayisi
        : null
    );
    formVars.yuklemeplandetay_456493_value = ReactSystemFunctions.toString(
      this,
      stateVars.YuklemePlan_Get_DetailById !== undefined
        ? stateVars.YuklemePlan_Get_DetailById?.length > 0
          ? stateVars.YuklemePlan_Get_DetailById[0].yuklenenKoliAdedi
          : null
        : this.state.YuklemePlan_Get_DetailById?.length > 0
        ? this.state.YuklemePlan_Get_DetailById[0].yuklenenKoliAdedi
        : null
    );
    formVars.yuklemeplandetay_355838_value = ReactSystemFunctions.toString(
      this,
      stateVars.YuklemePlan_Get_DetailById !== undefined
        ? stateVars.YuklemePlan_Get_DetailById?.length > 0
          ? stateVars.YuklemePlan_Get_DetailById[0].yuklenenPaletAgirlik
          : null
        : this.state.YuklemePlan_Get_DetailById?.length > 0
        ? this.state.YuklemePlan_Get_DetailById[0].yuklenenPaletAgirlik
        : null
    );
    formVars.yuklemeplandetay_728519_value = ReactSystemFunctions.value(
      this,
      stateVars.YuklemePlan_Get_DetailById !== undefined
        ? stateVars.YuklemePlan_Get_DetailById?.length > 0
          ? stateVars.YuklemePlan_Get_DetailById[0].mikroDagitimVar
          : null
        : this.state.YuklemePlan_Get_DetailById?.length > 0
        ? this.state.YuklemePlan_Get_DetailById[0].mikroDagitimVar
        : null
    );
    formVars.yuklemeplandetay_591289_options = stateVars.Get_Tanim_MusteriListe;
    formVars.yuklemeplandetay_591289_value =
      stateVars.YuklemePlan_Get_DetailById !== undefined
        ? stateVars.YuklemePlan_Get_DetailById?.length > 0
          ? stateVars.YuklemePlan_Get_DetailById[0].mikroDagitimFirmaId
          : null
        : this.state.YuklemePlan_Get_DetailById?.length > 0
        ? this.state.YuklemePlan_Get_DetailById[0].mikroDagitimFirmaId
        : null;
    formVars.yuklemeplandetay_899912_options =
      stateVars.Get_Tanim_MusteriNoktaListe;
    formVars.yuklemeplandetay_899912_value =
      stateVars.YuklemePlan_Get_DetailById !== undefined
        ? stateVars.YuklemePlan_Get_DetailById?.length > 0
          ? stateVars.YuklemePlan_Get_DetailById[0].mikroDagitimNokta
          : null
        : this.state.YuklemePlan_Get_DetailById?.length > 0
        ? this.state.YuklemePlan_Get_DetailById[0].mikroDagitimNokta
        : null;
    stateVars.Get_Tanim_MusteriNoktaListe =
      result?.data.get_Tanim_MusteriNoktaListe;

    formVars.yuklemeplandetay_899912_options =
      stateVars.Get_Tanim_MusteriNoktaListe;
    formVars.yuklemeplandetay_899912_value =
      stateVars.YuklemePlan_Get_DetailById !== undefined
        ? stateVars.YuklemePlan_Get_DetailById?.length > 0
          ? stateVars.YuklemePlan_Get_DetailById[0].mikroDagitimNokta
          : null
        : this.state.YuklemePlan_Get_DetailById?.length > 0
        ? this.state.YuklemePlan_Get_DetailById[0].mikroDagitimNokta
        : null;
    stateVars.YuklemePlan_Get_MasterById =
      result?.data.yuklemePlan_Get_MasterById;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.YuklemePlanDetayPageInit1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  YuklemePlanDetayPageInit1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    formVars.yuklemeplandetay_197656_value = ReactSystemFunctions.toString(
      this,
      stateVars.YuklemePlan_Get_DetailById !== undefined
        ? stateVars.YuklemePlan_Get_DetailById?.length > 0
          ? stateVars.YuklemePlan_Get_DetailById[0].teslimatNo
          : null
        : this.state.YuklemePlan_Get_DetailById?.length > 0
        ? this.state.YuklemePlan_Get_DetailById[0].teslimatNo
        : null
    );

    formVars.yuklemeplandetay_770540_value = ReactSystemFunctions.toString(
      this,
      stateVars.YuklemePlan_Get_DetailById !== undefined
        ? stateVars.YuklemePlan_Get_DetailById?.length > 0
          ? stateVars.YuklemePlan_Get_DetailById[0].urunAdi
          : null
        : this.state.YuklemePlan_Get_DetailById?.length > 0
        ? this.state.YuklemePlan_Get_DetailById[0].urunAdi
        : null
    );

    formVars.yuklemeplandetay_903658_value = ReactSystemFunctions.toString(
      this,
      stateVars.YuklemePlan_Get_DetailById !== undefined
        ? stateVars.YuklemePlan_Get_DetailById?.length > 0
          ? stateVars.YuklemePlan_Get_DetailById[0].yuklenenPaletSayisi
          : null
        : this.state.YuklemePlan_Get_DetailById?.length > 0
        ? this.state.YuklemePlan_Get_DetailById[0].yuklenenPaletSayisi
        : null
    );

    formVars.yuklemeplandetay_456493_value = ReactSystemFunctions.toString(
      this,
      stateVars.YuklemePlan_Get_DetailById !== undefined
        ? stateVars.YuklemePlan_Get_DetailById?.length > 0
          ? stateVars.YuklemePlan_Get_DetailById[0].yuklenenKoliAdedi
          : null
        : this.state.YuklemePlan_Get_DetailById?.length > 0
        ? this.state.YuklemePlan_Get_DetailById[0].yuklenenKoliAdedi
        : null
    );

    formVars.yuklemeplandetay_355838_value = ReactSystemFunctions.toString(
      this,
      stateVars.YuklemePlan_Get_DetailById !== undefined
        ? stateVars.YuklemePlan_Get_DetailById?.length > 0
          ? stateVars.YuklemePlan_Get_DetailById[0].yuklenenPaletAgirlik
          : null
        : this.state.YuklemePlan_Get_DetailById?.length > 0
        ? this.state.YuklemePlan_Get_DetailById[0].yuklenenPaletAgirlik
        : null
    );

    formVars.yuklemeplandetay_728519_value = ReactSystemFunctions.value(
      this,
      stateVars.YuklemePlan_Get_DetailById !== undefined
        ? stateVars.YuklemePlan_Get_DetailById?.length > 0
          ? stateVars.YuklemePlan_Get_DetailById[0].mikroDagitimVar
          : null
        : this.state.YuklemePlan_Get_DetailById?.length > 0
        ? this.state.YuklemePlan_Get_DetailById[0].mikroDagitimVar
        : null
    );

    formVars.yuklemeplandetay_591289_value = ReactSystemFunctions.toString(
      this,
      stateVars.YuklemePlan_Get_DetailById !== undefined
        ? stateVars.YuklemePlan_Get_DetailById?.length > 0
          ? stateVars.YuklemePlan_Get_DetailById[0].mikroDagitimFirmaId
          : null
        : this.state.YuklemePlan_Get_DetailById?.length > 0
        ? this.state.YuklemePlan_Get_DetailById[0].mikroDagitimFirmaId
        : null
    );

    stateVars.dataSource_591289 =
      stateVars.Get_Tanim_MusteriListe ?? this.state.Get_Tanim_MusteriListe;
    stateVars.dataSource_591289 =
      stateVars.Get_Tanim_MusteriListe ?? this.state.Get_Tanim_MusteriListe;

    formVars.yuklemeplandetay_899912_value = ReactSystemFunctions.toString(
      this,
      stateVars.YuklemePlan_Get_DetailById !== undefined
        ? stateVars.YuklemePlan_Get_DetailById?.length > 0
          ? stateVars.YuklemePlan_Get_DetailById[0].mikroDagitimNokta
          : null
        : this.state.YuklemePlan_Get_DetailById?.length > 0
        ? this.state.YuklemePlan_Get_DetailById[0].mikroDagitimNokta
        : null
    );

    stateVars.dataSource_899912 =
      stateVars.Get_Tanim_MusteriNoktaListe ??
      this.state.Get_Tanim_MusteriNoktaListe;
    stateVars.dataSource_899912 =
      stateVars.Get_Tanim_MusteriNoktaListe ??
      this.state.Get_Tanim_MusteriNoktaListe;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    return isErrorOccurred;
  };

  YuklemePlanDetayComponent_591289_onBlur = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      MusteriId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "yuklemeplandetay_591289_value",
            "value",
            "Get_Tanim_MusteriListe",
            "id",
            "id"
          )
        ),
        "Guid"
      ),
      UserId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.Get_Helpers_UserInfoByUserName !== undefined
            ? stateVars.Get_Helpers_UserInfoByUserName?.length > 0
              ? stateVars.Get_Helpers_UserInfoByUserName[0].id
              : null
            : this.state.Get_Helpers_UserInfoByUserName?.length > 0
            ? this.state.Get_Helpers_UserInfoByUserName[0].id
            : null
        ),
        "Guid"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "YuklemePlanDetay/YuklemePlanDetayComponent_591289_onBlur",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.Get_Tanim_MusteriNoktaListe =
      result?.data.get_Tanim_MusteriNoktaListe;

    formVars.yuklemeplandetay_899912_options =
      stateVars.Get_Tanim_MusteriNoktaListe;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.YuklemePlanDetayComponent_591289_onBlur1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  YuklemePlanDetayComponent_591289_onBlur1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.dataSource_899912 =
      stateVars.Get_Tanim_MusteriNoktaListe ??
      this.state.Get_Tanim_MusteriNoktaListe;
    stateVars.dataSource_899912 =
      stateVars.Get_Tanim_MusteriNoktaListe ??
      this.state.Get_Tanim_MusteriNoktaListe;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  YuklemePlanDetayComponent_674442_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.Confirm = await ReactSystemFunctions.confirmation(
      ReactSystemFunctions.translateCustomActions(
        this.ml,
        "24a2df8d_ecbd_3ff2_bf68_1a4713834568_confirmation",
        this.defaultML,
        "Yapılan değişiklikler iptal edilecek. Emin misiniz ?"
      ),
      "poppins",
      "",
      "",
      "#246dff"
    );

    if (stateVars.Confirm) {
      KuikaAppManager.showSpinner(this);

      stateVars.GoBack = await ReactSystemFunctions.goBack(this, null);

      this.props.form?.setFieldsValue(formVars);
      this.setState(stateVars);
      KuikaAppManager.hideSpinner(this);
    }

    return isErrorOccurred;
  };

  YuklemePlanDetayComponent_869540_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      PaletSayisi_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "yuklemeplandetay_903658_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      BrutAgirlik_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "yuklemeplandetay_355838_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      KoliAdedi_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "yuklemeplandetay_456493_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      UserId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.Get_Helpers_UserInfoByUserName !== undefined
            ? stateVars.Get_Helpers_UserInfoByUserName?.length > 0
              ? stateVars.Get_Helpers_UserInfoByUserName[0].id
              : null
            : this.state.Get_Helpers_UserInfoByUserName?.length > 0
            ? this.state.Get_Helpers_UserInfoByUserName[0].id
            : null
        ),
        "Guid"
      ),
      YuklemeDetayId_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.YuklemeDetayId ??
          this.props.screenInputs.yuklemedetayid,
        "Guid"
      ),
      MikroDagitimVar_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "yuklemeplandetay_728519_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "boolean"
      ),
      MikroDagitimNokta_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "yuklemeplandetay_899912_value",
            "value",
            "Get_Tanim_MusteriNoktaListe",
            "id",
            "id"
          )
        ),
        "Guid"
      ),
      YuklemeNo_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.YuklemePlan_Get_MasterById !== undefined
            ? stateVars.YuklemePlan_Get_MasterById?.length > 0
              ? stateVars.YuklemePlan_Get_MasterById[0].yuklemeNo
              : null
            : this.state.YuklemePlan_Get_MasterById?.length > 0
            ? this.state.YuklemePlan_Get_MasterById[0].yuklemeNo
            : null
        ),
        "string"
      ),
      FirmaAdi_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.Get_Helpers_UserInfoByUserName !== undefined
            ? stateVars.Get_Helpers_UserInfoByUserName?.length > 0
              ? stateVars.Get_Helpers_UserInfoByUserName[0].firmaAdi
              : null
            : this.state.Get_Helpers_UserInfoByUserName?.length > 0
            ? this.state.Get_Helpers_UserInfoByUserName[0].firmaAdi
            : null
        ),
        "string"
      ),
      templateId_2: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("", "string"),
        "string"
      ),
      receivers_2: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.YuklemePlan_Get_MasterById !== undefined
            ? stateVars.YuklemePlan_Get_MasterById?.length > 0
              ? stateVars.YuklemePlan_Get_MasterById[0].tasiyiciFirmaEPosta
              : null
            : this.state.YuklemePlan_Get_MasterById?.length > 0
            ? this.state.YuklemePlan_Get_MasterById[0].tasiyiciFirmaEPosta
            : null
        ),
        "string"
      ),
      subject_2: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName(
          "KYP Detay Güncellemesi",
          "string"
        ),
        "string"
      ),
      sender_2: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("", "string"),
        "string"
      ),
      cc_2: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("", "string"),
        "string"
      ),
      bcc_2: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("", "string"),
        "string"
      ),
      language_2: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("", "string"),
        "string"
      ),
      body_2: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetMailBody_TedarikciPlanDetayGuncelleme
        ),
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "YuklemePlanDetay/YuklemePlanDetayComponent_869540_onClick",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.YuklemePlan_Update_Detail =
      result?.data.yuklemePlan_Update_Detail;
    stateVars.GetMailBody_TedarikciPlanDetayGuncelleme =
      result?.data.getMailBody_TedarikciPlanDetayGuncelleme;
    stateVars.SendMail = result?.data.sendMail;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.YuklemePlanDetayComponent_869540_onClick1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  YuklemePlanDetayComponent_869540_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.GoBack = await ReactSystemFunctions.goBack(this, false);

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  async callCallbackFunction(diId: number, isFromMaster: boolean = false) {
    let isErrorOccurred = false;
    let pageInitCallerNavDiIDs = [] as number[];
    if (isFromMaster || pageInitCallerNavDiIDs.indexOf(diId) > -1) {
      await this.YuklemePlanDetayPageInit();
    }
  }
}
